import { InstrumentSchema } from '../../types/common';
import { makeIds } from '../../utils/instrumentId';
import { Content } from './Content';
import { Menu } from './Menu';
import { Select } from './Menu/Select';

const schema: InstrumentSchema = {
  supports: new Set(makeIds('ADVCASH', ['USD'])),
  components: { Content, Menu, Select },
};

export default schema;
